import React from "react";
import PageHeader from "../components/PageHeader";
import About from "../components/About";
import Founder from "../components/Founder";
import useSEO from "../lib/seo";

export default function AboutPage() {
  useSEO({
    title: "About LNZ | Engineers, Architects & Builders in Jamaica",
    description:
      "Meet LNZ Designs & Development Co. Ltd — a Jamaica-based engineering, architecture and construction firm founded in 2019 by Dr Leighton A. Ellis (CEng MICE). Two decades of Caribbean and UK practice.",
    path: "/about",
    keywords:
      "about LNZ, Dr Leighton Ellis, Chartered Civil Engineer Jamaica, CEng MICE, engineering firm Kingston, JIE President-Elect, ICE Americas Regional Chair",
  });
  return (
    <div data-testid="about-page">
      <PageHeader
        overline="ABOUT LNZ"
        title="A Caribbean firm engineered for "
        accent="excellence."
        description="LNZ Designs & Development Co. Ltd is Jamaica's integrated engineering, architecture and construction partner — established in 2019 and trusted across the region."
      />
      <About />
      <Founder />
    </div>
  );
}
